import { useState } from 'react';
import ChatWindow from '../components/ChatWindow';
import CitationSidebar from '../components/CitationSidebar';
import Footer from '../components/Footer';
import { cn } from '@/lib/utils';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';

const ChatbotPage = () => {
  const [selectedCitation, setSelectedCitation] = useState<{ text: string; url: string } | null>(null);

  const handleReferenceClick = (citation: { text: string; url: string }) => {
    setSelectedCitation(citation);
  };

  const handleSidebarClose = () => {
    setSelectedCitation(null);
  };

  return (
    <div className="flex flex-col m-4 mt-0 h-[95svh]">
      <div className="flex w-full gap-4 grow overflow-hidden py-2 px-1 relative">
        <ResizablePanelGroup direction="horizontal">
          <ResizablePanel>
            <div className="flex flex-col  mx-auto grow-[10] h-full">
              <ChatWindow onReferenceClick={handleReferenceClick} />
            </div>
          </ResizablePanel>
          <ResizableHandle className={cn('ml-2 mr-2', selectedCitation ? '' : ' hidden')} />
          {selectedCitation && (
            <>
              <ResizablePanel minSize={21.5} maxSize={75}>
                <div
                  id="citation-wrapper"
                  className={cn('rounded-lg bg-transparent grow-[1]', selectedCitation ? ' h-full' : 'hidden ')}>
                  <CitationSidebar citation={selectedCitation} onClose={handleSidebarClose} />
                </div>
              </ResizablePanel>
            </>
          )}
        </ResizablePanelGroup>
      </div>

      <Footer />
    </div>
  );
};

export default ChatbotPage;
